<template>
  <!-- The account menu (main_menu.dart _openAccountMenu; SI-7): your
       username, then Profile, My audio, Sounds, People, Settings, a
       separator and Import audio…. No Log out (it lives in Settings ›
       Account). Opened from the rail's mark and the phone Home avatar
       (accountMenu.open(anchorEl)). -->
  <v-menu
    v-model="open"
    :target="state.anchor || undefined"
    location="bottom start"
    offset="6"
    :close-on-content-click="true"
  >
    <div class="account-menu" role="menu" aria-label="Account">
      <div class="am-head">{{ username }}</div>
      <button
        v-for="item in items"
        :key="item.key"
        type="button"
        class="am-row"
        role="menuitem"
        :data-test="`account-menu-${item.key}`"
        @click="item.go()"
      >
        {{ item.label }}
      </button>
      <div class="am-sep" role="separator" />
      <button type="button" class="am-row" role="menuitem" data-test="account-menu-import" @click="pickFiles">
        Import audio…
      </button>
    </div>
  </v-menu>
  <input ref="files" type="file" class="am-file" accept=".wav,.aif,.aiff,.aifc,.flac" multiple @change="onFiles" />
</template>

<script>
import { accountMenuState } from "./accountMenu.js";

export default {
  name: "AccountMenu",
  data: () => ({ state: accountMenuState }),
  computed: {
    open: {
      get() {
        return this.state.open;
      },
      set(v) {
        this.state.open = v;
      },
    },
    username() {
      return this.$store.state.loggedInUser?.username || "";
    },
    items() {
      const go = (path) => () => this.$router.push(path).catch(() => {});
      return [
        { key: "profile", label: "Profile", go: go(`/users/${encodeURIComponent(this.username)}`) },
        { key: "my-audio", label: "My audio", go: go("/library/my-audio") },
        { key: "sounds", label: "Sounds", go: go("/sounds") },
        { key: "people", label: "People", go: go("/people") },
        { key: "settings", label: "Settings", go: go("/settings") },
      ];
    },
  },
  methods: {
    pickFiles() {
      this.$refs.files?.click();
    },
    onFiles(e) {
      const files = Array.from((e.target && e.target.files) || []);
      if (files.length) this.$store.dispatch("stageNewSessionAudio", files);
      e.target.value = "";
    },
  },
};
</script>

<style scoped>
.account-menu {
  min-width: 180px;
  max-width: 320px;
  padding: 5px;
  border-radius: 8px;
  background: var(--cl-menu);
  border: 1px solid var(--cl-border-default);
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
}
.am-head {
  padding: 3px 10px 5px;
  font: 400 11px/14px var(--cl-font);
  color: var(--cl-label-3);
}
.am-row {
  height: 24px;
  padding: 0 10px;
  border: none;
  border-radius: 5px;
  background: transparent;
  color: var(--cl-label);
  font: 400 13px/16px var(--cl-font);
  text-align: left;
  cursor: pointer;
}
.am-row:hover,
.am-row:focus-visible {
  background: var(--cl-accent);
  color: var(--cl-on-fill);
  outline: none;
}
.am-sep {
  height: 1px;
  margin: 4px 8px;
  background: var(--cl-border-default);
}
:root[data-density="touch"] .account-menu {
  width: 300px;
  max-width: 300px;
  padding: 0;
  border-radius: 14px;
  overflow: hidden;
}
:root[data-density="touch"] .am-head {
  padding: 10px 16px 6px;
  font-size: 13px;
}
:root[data-density="touch"] .am-row {
  height: 46px;
  padding: 0 16px;
  border-radius: 0;
  font-size: 17px;
  border-top: 1px solid var(--cl-separator);
}
:root[data-density="touch"] .am-row:hover {
  background: var(--cl-hover);
  color: var(--cl-label);
}
:root[data-density="touch"] .am-sep {
  height: 6px;
  margin: 0;
  background: rgba(0, 0, 0, 0.25);
}
.am-file {
  display: none;
}
</style>
